<template>
    <section >
       <nav class="navbar navbar-expand-lg navbar-dark bg-dark evangelio-lectura ">
        <a class="navbar-brand p-3" href="/"><img src="/images/logo.svg"><p class="logo-titulo">Parroquia del Espíritu Santo</p></a>
       <button  v-if="isAuthenticated" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>


        <div v-if="isAuthenticated" class="collapse navbar-collapse"  id="navbarNavDropdown">
          <ul class="navbar-nav"  style="margin-left: auto;">
           
            <li class="nav-item dropdown active">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Misal
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <router-link class="dropdown-item" to="/misas">Todas las misas</router-link>
                <router-link class="dropdown-item" to="/misas/agrega">Agregar misa</router-link>
              </ul>
            </li>
             <li class="nav-item">
              <a class="nav-link" href="#" @click="logout()">Cerrar Sesión</a>
            </li>
          </ul>
        </div>
    </nav>
        <div class="container p-5 pt-2" >
            <h1>Agrega Evangelio</h1>
            <form @submit.prevent="getAction">
                <div class="row">
                    <div class="col-12 col-md-6 form-group p-2">
                        <label>Fecha <span class="text-danger">*</span></label>
                        <input type="date" v-model="evangelio.MIS_FECHA" required class="form-control form-control-xs" /> 
                    </div>
                    <div class=" col-md-6 "></div>
                    <div class="col-12 col-md-6 form-group p-2">
                        <h5>Primera Lectura</h5>
                        <label>Versículo<span class="text-danger">*</span></label>
                        <input type="text" v-model="evangelio.MIS_PRIMERALECTURA_VERSICULO"  class="form-control form-control-xs" /> 
                        <label>Texto<span class="text-danger">*</span></label>
                        <Editor class="form-control form-control-sm"  v-model="evangelio.MIS_PRIMERALECTURA" />
                    </div>
                    
                    <div class="col-12 col-md-6 form-group p-2">
                        <h5>Segunda Lectura</h5>
                        <label>Versículo<span class="text-danger">*</span></label>
                        <input type="text" v-model="evangelio.MIS_SEGUNDALECTURA_VERSICULO"  class="form-control form-control-xs" /> 
                        <label>Texto<span class="text-danger">*</span></label>
                        <Editor class="form-control form-control-sm"  v-model="evangelio.MIS_SEGUNDALECTURA" />
                    </div>
                   
                    <div class="col-12  form-group p-2">
                        <label>Meditatio<span class="text-danger">*</span></label>
                        <Editor class="form-control form-control-sm"  v-model="evangelio.MIS_MEDITATIO" />
                    </div>
                    <div class="col-12  form-group p-2">
                        <label>Oratio<span class="text-danger">*</span></label>
                        <Editor class="form-control form-control-sm"  v-model="evangelio.MIS_ORATIO" />
                    </div>
                    <div class="col-12 form-group p-2">
                        <label>Actio<span class="text-danger">*</span></label>
                        <Editor class="form-control form-control-sm"  v-model="evangelio.MIS_ACTIO" />
                    </div>
                    <div class="col-12 form-group p-2">
                        <h5>Evangelio</h5>
                        <label>Versículo<span class="text-danger">*</span></label>
                        <input type="text" v-model="evangelio.MIS_EVANGELIO_VERSICULO"  class="form-control form-control-xs" /> 
                        <label>Texto<span class="text-danger">*</span></label>
                        <Editor class="form-control form-control-sm"  v-model="evangelio.MIS_EVANGELIO" />
                    </div>
                  
                    <div class="col-12 form-group p-2">
                        <label>Reflexion</label>
                        <Editor class="form-control form-control-sm" v-model="evangelio.MIS_REFLEXION"  />
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 text-left">
                        <router-link to="/misas" class="btn btn-outline-secondary btn-xs">Regresar</router-link>
                    </div>
                    <div class="col-6 justify-content-end d-flex">
                        <button class="btn btn-success btn-xs">{{ modo }}</button>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import Editor from './EditorComponent.vue'

export default {
    components: {
        Editor,
    },
    data(){
        return{
            evangelio: [],
            modo: 'Agregar'
        }
    },
    mounted(){
        console.log(this.urlName)
        if(this.urlName != '/misas/agrega' ){
            this.getEvangelio();
            this.modo = 'Guardar Cambios'
        }
    },
    computed:{
        urlName(){
            return this.$route.path
        },
        isAuthenticated(){
            return this.$auth0.isAuthenticated.value
        }
    },
    methods:{
        logout(){
            this.$auth0.logout({ returnTo: window.location.origin });
        },
        getAction(){
            if(this.modo == 'Agregar'){
                this.addEvangelio()
            }else{
                this.modificaEvangelio()
            }   
        },
        addEvangelio(){
            fetch(process.env.VUE_APP_PHP_URL,{
                method:'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({  accion: 'addMisa',  
                                        f: this.evangelio.MIS_FECHA,
                                        pl: (this.evangelio.MIS_PRIMERALECTURA ? this.evangelio.MIS_PRIMERALECTURA : ''), 
                                        plv: (this.evangelio.MIS_PRIMERALECTURA_VERSICULO ? this.evangelio.MIS_PRIMERALECTURA_VERSICULO : ''),
                                        sl: (this.evangelio.MIS_SEGUNDALECTURA ? this.evangelio.MIS_SEGUNDALECTURA : ''),
                                        slv: (this.evangelio.MIS_SEGUNDALECTURA_VERSICULO ? this.evangelio.MIS_SEGUNDALECTURA_VERSICULO : ''),
                                        m: (this.evangelio.MIS_MEDITATIO ? this.evangelio.MIS_MEDITATIO : ''),
                                        a: (this.evangelio.MIS_ACTIO ? this.evangelio.MIS_ACTIO : ''),
                                        o: (this.evangelio.MIS_ORATIO ? this.evangelio.MIS_ORATIO : ''),
                                        e: (this.evangelio.MIS_EVANGELIO ? this.evangelio.MIS_EVANGELIO : ''),
                                        ev: (this.evangelio.MIS_EVANGELIO_VERSICULO ? this.evangelio.MIS_EVANGELIO_VERSICULO : ''),
                                        r: (this.evangelio.MIS_REFLEXION ? this.evangelio.MIS_REFLEXION : '') })
            }).then(res=>{
                if(res.ok){
                    this.$router.replace('/misas');
                }
            })
        },
        async getEvangelio(){
            await fetch(process.env.VUE_APP_PHP_URL,{
                method:'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({  accion: 'getMisa', id: this.$route.params.id })
            }).then(res=>res.json())
            .then((data)=>{
                console.log(data)
                this.evangelio = data
            })
        },
        modificaEvangelio(){
            fetch(process.env.VUE_APP_PHP_URL,{
                method:'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({  accion: 'editMisa',  
                                        id: this.evangelio.MIS_ID,
                                        f: this.evangelio.MIS_FECHA,
                                        pl: (this.evangelio.MIS_PRIMERALECTURA ? this.evangelio.MIS_PRIMERALECTURA : ''), 
                                        plv: (this.evangelio.MIS_PRIMERALECTURA_VERSICULO ? this.evangelio.MIS_PRIMERALECTURA_VERSICULO : ''),
                                        sl: (this.evangelio.MIS_SEGUNDALECTURA ? this.evangelio.MIS_SEGUNDALECTURA : ''),
                                        slv: (this.evangelio.MIS_SEGUNDALECTURA_VERSICULO ? this.evangelio.MIS_SEGUNDALECTURA_VERSICULO : ''),
                                        m: (this.evangelio.MIS_MEDITATIO ? this.evangelio.MIS_MEDITATIO : ''),
                                        a: (this.evangelio.MIS_ACTIO ? this.evangelio.MIS_ACTIO : ''),
                                        o: (this.evangelio.MIS_ORATIO ? this.evangelio.MIS_ORATIO : ''),
                                        e: (this.evangelio.MIS_EVANGELIO ? this.evangelio.MIS_EVANGELIO : ''),
                                        ev: (this.evangelio.MIS_EVANGELIO_VERSICULO ? this.evangelio.MIS_EVANGELIO_VERSICULO : ''),
                                        r: (this.evangelio.MIS_REFLEXION ? this.evangelio.MIS_REFLEXION : '') })
            }).then(res=>{
                if(res.ok){
                    this.$router.replace('/misas');
                }
            })
        }   
    }
}
</script>